import { removeFromCart } from '../../../../api/cart/remove-from-cart';
import qualityEvents from '../../../../services/quality-events/quality-events';
import { CART_REMOVE_FROM_CART_SOURCE } from '../../../../services/quality-events/quality-events-pages/cart-page-quality-events.constants';
import foldAnimation from '../../../../utils/animations/fold';
import enhancedEcommerce from '../../../../utils/enhanced-ecommerce';

type RemoveItemFromCartProps = {
    item: CartItem;
    itemIndex?: number;
    reset: (cart: Cart) => void;
};

const removeItemFromCart = ({ item, itemIndex, reset }: RemoveItemFromCartProps) => {
    foldAnimation(`.cart-item-${item.material.id}`, () => {
        removeFromCart({}, { id: item.material.id }).then(
            ({
                data: {
                    items: { cart }
                }
            }) => reset(cart)
        );
    });

    enhancedEcommerce.tracker.removeFromCart(item.material);
    qualityEvents.cartPage.removeFromCart({
        item: item.material,
        itemIndex,
        source: CART_REMOVE_FROM_CART_SOURCE.CART_PAGE
    });
};

export default removeItemFromCart;
